import GODataKU from './GODataKU'

export default GODataKU
